import { gql } from "@apollo/client";

const GET_ENTITY_IMAGE_UPLOAD_URL = gql`
  query GetEntityImageUploadUrl($input: GetEntityImageUploadUrlInput!) {
    getEntityImageUploadUrl(input: $input) {
      success
      uploadUrl
      error
    }
  }
`;

const DELETE_ENTITY_IMAGE = gql`
  mutation DeleteEntityImage($input: DeleteEntityImageInput!) {
    deleteEntityImage(input: $input) {
      success
      error
    }
  }
`;

export { GET_ENTITY_IMAGE_UPLOAD_URL, DELETE_ENTITY_IMAGE };
